import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const Portal = ({ id = 'portal', children }) => {
  const [portalRoot, setPortalRoot] = useState(null);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      let root = document.getElementById(id);
      if (!root) {
        root = document.createElement('div');
        root.id = id;
        document.body.appendChild(root);
      }
      setPortalRoot(root);
    }
    return () =>
      portalRoot && children.forEach(child => portalRoot.removeChild(child));
  }, []);

  return portalRoot && ReactDOM.createPortal(children, portalRoot);
};

Portal.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Portal;
